import Menu from 'Models/Menu';

export default [
  Menu.uploadLabTest,
  Menu.setHomePage,
  Menu.checkUpdate,
];
